import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IEvaluationResult } from '../../data/attendance-reports';

@Component({
  selector: 'app-evaluation-detail-modal',
  templateUrl: './evaluation-detail-modal.component.html',
  styleUrls: ['./evaluation-detail-modal.component.scss']
})
export class EvaluationDetailModalComponent {
  constructor(
    public dialogRef: MatDialogRef<EvaluationDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IEvaluationResult
  ) {}
}
